export const resolveBannerSlideIndex = (
  contentIndex: number,
  infiniteLoop: boolean,
  visibleCards: number
): number => (infiniteLoop ? contentIndex + visibleCards : contentIndex)

export const isNonAdjacentBannerSlide = (
  fromSlide: number,
  toSlide: number
): boolean => Math.abs(toSlide - fromSlide) > 1
